import { getQuoteFeederTableAddress } from "../sourceServices";
import { QUOTE_FEED_COLUMN } from "./constants";

export async function setProducerQuoteFeederOptions(
  context: Excel.RequestContext,
  sheet: Excel.Worksheet,
  table: Excel.Table
) {
  let sourceAddress = await getQuoteFeederTableAddress(context);

  let fullRange = table.getRange();
  fullRange.load(["columnCount", "rowCount", "address"]);
  await context.sync();

  let address = QUOTE_FEED_COLUMN + "2:" + QUOTE_FEED_COLUMN + fullRange.rowCount;
  let range = sheet.getRange(address);

  range.dataValidation.rule = {
    list: {
      inCellDropDown: true,
      source: "=" + sourceAddress,
    },
  };

  await context.sync();
}
